<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$swal("Oops..", 'Usuário não autenticado', "error");
  }
};
</script>
